import { render } from "./Prospects.vue?vue&type=template&id=026a6bbb&scoped=true"
import script from "./Prospects.vue?vue&type=script&lang=js"
export * from "./Prospects.vue?vue&type=script&lang=js"

import "./Prospects.vue?vue&type=style&index=0&id=026a6bbb&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-026a6bbb"]])

export default __exports__